/**
 * Original emblem for the ThemisLex portal: a scales-of-justice roundel.
 * Drawn from scratch for this project — not derived from any existing site's
 * crest or assets.
 */
export function Emblem({ size = 40, className = "" }: { size?: number; className?: string }) {
  return (
    <svg
      viewBox="0 0 48 48"
      width={size}
      height={size}
      className={className}
      role="img"
      aria-label="ThemisLex emblem"
      fill="none"
    >
      {/* roundel */}
      <circle cx="24" cy="24" r="22.25" stroke="currentColor" strokeWidth="1.6" />
      <circle cx="24" cy="24" r="18.75" stroke="currentColor" strokeWidth="0.7" opacity="0.45" />
      {/* beam, post and finial */}
      <path d="M11 17.5h26" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M24 13v21" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <circle cx="24" cy="10.2" r="1.9" fill="currentColor" />
      {/* left pan */}
      <path d="M14 17.5 10 25m4-7.5 4 7.5" stroke="currentColor" strokeWidth="0.9" />
      <path d="M9.5 25a4.5 4.5 0 0 0 9 0" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
      {/* right pan */}
      <path d="M34 17.5 30 25m4-7.5 4 7.5" stroke="currentColor" strokeWidth="0.9" />
      <path d="M29.5 25a4.5 4.5 0 0 0 9 0" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
      {/* base */}
      <path d="M18 37.5h12" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M21 34h6" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" />
    </svg>
  );
}
